import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    customBackground?: {
      main: string;
      light: string;
    };
  }
  interface PaletteOptions {
    customBackground?: {
      main: string;
      light: string;
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2e9cca',
      light: '#4BACD5',
      dark: '#1F6D8D',
    },
    secondary: {
      main: '#29648a',
      light: '#3D7EA3',
      dark: '#1C4660',
    },
    customBackground: {
      main: '#2e9cca',
      light: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: 'var(--font-geist-sans)',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '8px 16px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#000000',
          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export { theme };